module.exports = __webpack_public_path__ + "static/img/test_top1.f38d81c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/test_top1.jpg
// module id = 5Bz3
// module chunks = 0